import * as React from 'react';
import Dialog from '@mui/material/Dialog';
import Chat from './Chat';

export default function ChatModal({ handleClose, open, rowData }) {

  return (
    <React.Fragment>

      <Dialog
        fullWidth
        open={open}
        onClose={handleClose}
      >
       <Chat rowData={rowData}/>
      </Dialog>
    </React.Fragment>
  );
}